import { gql } from '@generated/gql';

const addAttributionDetailsMutation = gql(`
  mutation AddAttributionDetails($basketId: ID!, $details: AddAttributionDetailsInput!) {
    addAttributionDetails(
      basketId: $basketId
      details: $details
    ) {
      ...AttributionDetails
    }
  }
`);

const addBasketAttributionFromAppointmentMutation = gql(`
  mutation AddBasketAttributionFromAppointment($id: ID!, $basketId: ID!) {
    addBasketAttributionFromAppointment(id: $id, basketId: $basketId)
  }
`);

gql(`
  fragment AttributionDetails on AttributionDetails {
    assistant {
      partner {
        id
        positionId
      }
      sales {
        oktaUsername
      }
    }
    referrer {
      partner {
        positionId
      }
      partnerManual {
        positionId
      }
      customer {
        accountNumber
      }
      customerManual {
        accountNumber
      }
      affiliate {
        uswitch {
          _empty_
        }
      }
      sales {
        oktaUsername
      }
      connector {
        id
        shortId
      }
    }
    supportingPartner {
      partner {
        id
        positionId
      }
    }
  }
`);

const getBasketAttribution = gql(`
  query GetAttribution($basketId: ID!) {
    attributionDetails(basketId: $basketId) {
      ...AttributionDetails
    }
  }
`);

const getReferralCodeQuery = gql(`
  query GetReferralCode($accountId: String!) {
    referralCode(accountId: $accountId)
  }
`);

export {
  addAttributionDetailsMutation,
  addBasketAttributionFromAppointmentMutation,
  getBasketAttribution,
  getReferralCodeQuery,
};
